import {createAction, createAsyncThunk} from '@reduxjs/toolkit';
import {Results} from 'common/models/success';
import {setErrorAction} from 'ui/store/system/actions/setError';
import getRequestError from 'ui/store/utils/getRequestError';
import withAbortRequest from 'ui/store/utils/withAbortRequest';
import {sdk} from 'ui/utils/sdk';

import {namespace} from '../constants';
import {AsyncThunkConfig, ReducerCallback} from '../success.types';

interface PrepareResults {
    answerKey: string;
}

export const prepareResultsAction = createAction<Results>(`${namespace}/prepareResults`);

export const reducerPrepareResults: ReducerCallback<Results> = (state, {payload}) => {
    state.results = payload;
};

const prepareResults = createAsyncThunk<void, PrepareResults, AsyncThunkConfig<void>>(
    'prepareResults',
    async ({answerKey}, {signal, dispatch}) =>
        withAbortRequest(
            sdk.form.getResults({answerKey}).then((results) => {
                dispatch(prepareResultsAction(results));
            }),
            signal,
        )
            .catch(getRequestError)
            .catch((status) => {
                dispatch(setErrorAction(status));
                return status;
            }),
);

export default prepareResults;
